// Mock addresses used by all three Revenue pages so they can render the
// existing pricing components with `mock=true` and no backend. Same cast
// (ids/names/cities) as PREVIEW_ADDRESSES in demo-preview.page.ts so the
// Revenue/Optimizer pages and the leasing hub / offline preview mode agree
// on one set of demo properties.

export interface MockAddress {
  id: number;
  address_name: string;
  display_name: string;
  city: string;
  state: string;
  color?: string;
}

export const MOCK_ADDRESSES: MockAddress[] = [
  { id: 990001, address_name: 'Palmetto House',          display_name: 'Palmetto House',          city: 'Charleston', state: 'SC', color: '#679BF8' },
  { id: 990002, address_name: 'Ferncreek Rooming House', display_name: 'Ferncreek Rooming House', city: 'Orlando',     state: 'FL', color: '#9FC65B' },
  { id: 990003, address_name: 'Cadence Cottage',         display_name: 'Cadence Cottage',         city: 'Boise',       state: 'ID', color: '#F1A76E' },
];

// Default for pages that only render one address (Booking Settings / Market for now).
export const MOCK_ADDRESS = MOCK_ADDRESSES[0];
